const loginInfo = localStorage.getItem('loginInfo') ? JSON.parse(localStorage.getItem('loginInfo')) : {};
const state = {
    token: loginInfo.token ? loginInfo.token : '',
    refreshToken: loginInfo.refreshToken ? loginInfo.refreshToken : '',
    name: loginInfo.name ? loginInfo.name : '',
    menu: loginInfo.menu ? loginInfo.menu : '',
    toolbar: loginInfo.toolbar ? loginInfo.toolbar : '',
    avatar: loginInfo.avatar ? loginInfo.avatar : '',
};

const mutations = {
    SET_LOGININFO: (state, INFO) => {
        localStorage.removeItem('loginInfo');
        localStorage.setItem('loginInfo', JSON.stringify(INFO));
        state.token = INFO.token;
        state.name = INFO.name;
        state.menu = INFO.menu;
        state.toolbar = INFO.toolbar;
        state.avatar = INFO.avatar;
        state.refreshToken = INFO.refreshToken;
    },
    REMOVE_LOGININFO: (state) => {
        localStorage.removeItem('loginInfo');
        state.token = '';
        state.name = '';
        state.menu = '';
        state.toolbar = '';
        state.avatar = '';
        state.refreshToken = '';
    }
};

const actions = {
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
